export enum MattingType {
    Human = 0, // 人像
    Thing = 1, // 物体
    Icon = 2, // 图标
    Close = -2, // 关闭
    Clothing = -3, // 衣服分割
}

export type ENV = 'pre' | 'beta' | 'release';

export interface MattingImageInfo {
    url: string;
    name: string;
    width: number;
    height: number;
    size: number;
    way?: string;
    picID?: string;

    originalImageURL?: string;
    fileType?: string;

    mattingInfo?: MattingInfo;
}

export interface MattingInfo {
    maskURL: string;
    mattingType: MattingType;
    useBlurFilterRun: boolean;
    // xywh detection box returned by the cutout algorithm when a seal/logo is detected
    seal_bbox?: [number, number, number, number];
    // 算法前景估计图
    foregroundEstimateImageURL?: string;
    // 当前图片是否开启抠图评价，仅当图片第一次抠图时出现
    isFirstUsedForCurrentImage?: boolean;
    position?: number[];
    msg_id?: string;
}

export type SodResult = {
    code: number;
    message: string;
} & MattingInfo;

// 人体解析，结果枚举
export enum SegmentationLabel {
    Background = '0', // 背景
    Hat = '1', // 帽子
    Hair = '2', // 头发
    Gloves = '3', // 手套
    Sunglasses = '4', // 太阳眼镜
    Top = '5', // 上衣
    Dress = '6', // 连衣裙
    Coat = '7', // 外套
    Socks = '8', // 袜子
    Pants = '9', // 裤子
    Scarf = '10', // 围巾
    Skirt = '11', // 裙子
    Jumpsuit = '12', // 连体衣
    DummyPillar = '13', // 假人柱子
    LeftShoe = '14', // 左鞋
    RightShoe = '15', // 右鞋
    Face = '16', // 脸
    Scalp = '17', // 头皮
    TorsoSkin = '18', // 躯干皮肤
    LeftArm = '19', // 左臂
    LeftHand = '20', // 左手
    RightArm = '21', // 右臂
    RightHand = '22', // 右手
    LeftLeg = '23', // 左腿
    RightLeg = '24', // 右腿
    HandheldItem = '25', // 手持物
    Bag = '26', // 包
    Accessory = '27', // 饰品
    Belt = '28', // 腰带
    Headwear = '29', // 头饰
    Mask = '30', // 口罩
    ArmProtector = '31', // 护袖
    Tie = '32', // 领带
    TransparentGlasses = '33', // 透明眼镜
}
